import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CheckInsService } from '@careapp-group/ng-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import * as selectors from '../reducers/index';
import { getSelectedId, ORGANISATIONS } from '../reducers/index';
import { CheckIns } from './check-ins.actions';
@Injectable()
export class CheckInsEffects {
  create = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckIns.RequestCreateAction),
      withLatestFrom(this.store.select(selectors.getSelected(ORGANISATIONS))),
      switchMap(([action, organisation]) => {
        return this.checkInsService
          .createCheckIn({
            createCheckInDto: {
              customerId: action.payload.customerId,
              score: action.payload.score,
              checkInTagId: action.payload.checkInTagId,
            },
          })
          .pipe(
            map((res) => CheckIns.ResponseSuccessCreateAction({ payload: res })),
            tap(() =>
              this.router.navigate([
                '/',
                organisation.tenantId,
                'organisations',
                organisation.id,
                'feed',
              ])
            ),
            catchError((res) => of(CheckIns.ResponseFailCreateAction(res)))
          );
      })
    )
  );

  fetchAll = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckIns.RequestRetrieveAllAction),
      withLatestFrom(
        this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)),
        this.store.select(selectors.statistics.getFilters)
      ),
      switchMap(([action, org, filters]) => {
        return this.checkInsService
          .listCheckIns({
            limit: null,
            skip: null,
            startDate: filters?.startDate?.toISOString(),
            endDate: filters?.endDate?.toISOString(),
            organisationId: org,
            customerId: null,
          })
          .pipe(
            map((res) => CheckIns.ResponseSuccessRetrieveAllAction({ payload: res })),
            catchError((error) => of(CheckIns.ResponseFailRetrieveAllAction({ error })))
          );
      })
    )
  );

  fetchForSelectedCustomer = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckIns.RequestCheckInsForSelectedCustomer),
      withLatestFrom(this.store.select(selectors.getSelectedId(selectors.CUSTOMERS))),
      map(([action, customerId]) => CheckIns.RequestCheckInsForCustomer({ customerId: customerId }))
    )
  );

  fetchForCustomer = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckIns.RequestCheckInsForCustomer),
      withLatestFrom(this.store.select(selectors.statistics.getFilters)),
      switchMap(([action, filters]) => {
        return this.checkInsService
          .listCheckIns({
            limit: null,
            skip: null,
            startDate: filters?.startDate?.toISOString(),
            endDate: filters?.endDate?.toISOString(),
            organisationId: null,
            customerId: action.customerId,
          })
          .pipe(
            map((payload) => CheckIns.ResponseSuccessRetrieveAllAction({ payload })),
            catchError((error) => of(CheckIns.ResponseFailRetrieveAllAction({ error })))
          );
      })
    )
  );

  constructor(
    private actions$: Actions<any>,
    private store: Store<any>,
    private router: Router,
    private checkInsService: CheckInsService
  ) {}
}
